import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl, formatAndThrowApiError } from '@/helpers/api';

export const useTenantsForUser = () => {
  const urlStr = `${getApiUrl()}/tenant-user`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useTenantUsers = () => {
  const urlStr = `${getApiUrl()}/admin/tenant-user`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        formatAndThrowApiError(err);
      }
    },
    {
      dedupingInterval: 60000, // 60 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};

export const useInviteTenantUser = () => {
  const inviteTenantUser = async (payload) => {
    try {
      const url = `${getApiUrl()}/admin/tenant-user/invite`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return inviteTenantUser;
};

export const useActivateTenantUser = () => {
  const activateTenantUser = async (tenantUserActivationId) => {
    try {
      const url = `${getApiUrl()}/tenant-user/activate/${tenantUserActivationId}`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return activateTenantUser;
};
